import { configureStore } from '@reduxjs/toolkit';
import reducers from './reducers';

export default function getStore(initialState = {}) {
  return configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
    preloadedState: initialState,
  });
}
